import { DEFAULT_ZOOM_PERCENT, MAX_ZOOM_PERCENT, MIN_ZOOM_PERCENT } from './zoom-presets';

const STORAGE_PREFIX = 'vatix:doc-zoom';

export const zoomStorageKey = (userUuid: string | undefined, entityId: string): string =>
  `${STORAGE_PREFIX}:${userUuid ?? 'anonymous'}:${entityId}`;

export const clampZoomPercent = (zoomPercent: number): number =>
  Math.min(MAX_ZOOM_PERCENT, Math.max(MIN_ZOOM_PERCENT, Math.round(zoomPercent)));

export function readStoredZoomPercent(userUuid: string | undefined, entityId: string): number {
  try {
    const raw = window.localStorage.getItem(zoomStorageKey(userUuid, entityId));
    if (raw === null) return DEFAULT_ZOOM_PERCENT;
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? clampZoomPercent(parsed) : DEFAULT_ZOOM_PERCENT;
  } catch {
    return DEFAULT_ZOOM_PERCENT;
  }
}

export function writeStoredZoomPercent(
  userUuid: string | undefined,
  entityId: string,
  zoomPercent: number
): void {
  try {
    window.localStorage.setItem(zoomStorageKey(userUuid, entityId), String(clampZoomPercent(zoomPercent)));
  } catch {}
}
